import { HttpClient } from 'api/HttpClient';
import { ApplicationDto } from 'prequalificationV2/api/ApplicationApi';
import { BorrowerRole } from 'enums/BorrowerRole';
import { BorrowerIncomeType, OtherIncomeTypes } from 'enums/BorrowerIncomeType';
import { IncomeW2Type } from 'api/UnderwritingApi';

export interface IncomeInfoDto {
  incomeType: BorrowerIncomeType | OtherIncomeTypes;
  income: number;
}

export interface UpdateIncomeInfoRequestDto {
  applicationId: string;
  borrowerType: BorrowerRole;
  incomes: IncomeInfoDto[];
  isHomemakerUnemployed: boolean;
  other?: string | null;
  w2Incomes?: {
    companyName1?: string | null;
    companyMappingId1?: string | null;
    incomeW2Type1?: IncomeW2Type | null;
    companyName2?: string | null;
    companyMappingId2?: string | null;
    incomeW2Type2?: IncomeW2Type | null;
    companyName3?: string | null;
    companyMappingId3?: string | null;
    incomeW2Type3?: IncomeW2Type | null;
  };
}

class IncomesApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL || '');
  }

  public async updateIncomeInfo(updateIncomeInfoRequestDto: UpdateIncomeInfoRequestDto): Promise<ApplicationDto> {
    return this.instance.put('/incomes', updateIncomeInfoRequestDto).then((response) => response.data);
  }
}

export const incomesApi = new IncomesApi();
